@if (showAppLauncher) {
  <div class="applauncher-loading-container">
    Your app is loading, we're checking your login status. please wait...
  </div>
}
<router-outlet (activate)="onActivate()" />
